module.exports = __webpack_public_path__ + "static/project-17c-ece8612c781e5218eb0be49e9751e204.png";